//
// fancybox.js
// Theme module
//

'use strict'

window.Fancybox.bind("[data-fancybox]", {
    // Your custom options
    on: {
        done: (fancybox, slide) => {
            // iframe rutube autoplay
            if (fancybox.isCurrentSlide(slide) && slide.type === "iframe" && slide.src.includes("https://rutube.ru")) {
                slide.iframeEl.contentWindow.postMessage(JSON.stringify({
                    type: 'player:play',
                    data: {}
                }), '*');
            }
        },
    },
});